import React from "react";
import { CAP_LABEL, provName, usd } from "./llmUtil";
import { Delta } from "./Delta";

export function SpendCard({ p, thresholds, prev }) {
  const pct = p.budget_pct ?? null;
  const top = Math.max(...thresholds, 0);
  const low = Math.min(...thresholds, 100);
  const bar = pct == null ? "" : pct >= top ? "bg-rose-500" : pct >= low ? "bg-amber-500" : "bg-emerald-500";
  const caps = Object.entries(p.by_capability || {});
  return (
    <div className="aivora-card p-4" data-testid={`llm-spend-${p.provider}`}>
      <div className="flex items-start justify-between gap-2">
        <div>
          <p className="text-sm font-bold text-slate-900">{provName(p.provider)}</p>
          <p className="text-[11px] text-slate-500">{p.calls_own} panggilan sendiri · {p.calls_emergent} Emergent · {p.fallbacks} fallback · {p.errors} error</p>
        </div>
        <div className="text-right">
          <p className="text-lg font-black text-slate-900" data-testid={`llm-spend-usd-${p.provider}`}>{usd(p.usd_own)}</p>
          {prev && <div className="mt-0.5 flex flex-col items-end gap-0.5"><Delta now={p.usd_own || 0} prev={prev.usd_own || 0} testid={`spend-delta-${p.provider}`} /><span className="text-[10px] text-slate-400">key sendiri vs bulan lalu</span></div>}
          {p.usd_emergent > 0 && <p className="text-[11px] font-semibold text-amber-700">+{usd(p.usd_emergent)} Emergent</p>}
        </div>
      </div>
      {p.budget_usd != null ? (
        <div className="mt-3" data-testid={`llm-spend-budget-${p.provider}`}>
          <div className="relative h-2 overflow-hidden rounded-full bg-slate-100">
            <div className={`h-full rounded-full ${bar}`} style={{ width: `${Math.min(pct || 0, 100)}%` }} />
            {thresholds.map((t) => <span key={t} className="absolute top-0 h-full w-px bg-slate-400/60" style={{ left: `${t}%` }} title={`${t}%`} />)}
          </div>
          <p className="mt-1 text-[11px] text-slate-500">{(pct || 0).toFixed(1)}% dari anggaran {usd(p.budget_usd, 2)}</p>
        </div>
      ) : <p className="mt-3 text-[11px] text-slate-400">Tanpa anggaran</p>}
      {caps.length > 0 && (
        <ul className="mt-3 space-y-1 border-t border-slate-100 pt-3 text-[11px] text-slate-600">
          {caps.map(([c, v]) => <li key={c} className="flex justify-between"><span>{CAP_LABEL[c] || c}</span><span>{v.calls_own ?? 0}× · {usd(v.usd_own)}</span></li>)}
        </ul>
      )}
    </div>
  );
}
